module.exports = __webpack_public_path__ + "img/captcha_bg.7a0a3df0.png";